// @react
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
// @types
// @graphQL
// @libraries
import { makeStyles, Theme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
// @commons
// @components
import Container from '@bit/atd.web.container'
import Grid from '@bit/atd.web.grid'
import Spacer from '@bit/atd.web.spacer'
import Navigation from 'modules/onBoarding/components/_common/Navigation'
import TopicsList from 'modules/common/components/TopicsList'
import { Slide } from '@material-ui/core'
import { Direction, NavigationContext } from 'modules/common/context/navigation'
import useNavigation, { SuccessAction } from '../../../hooks/useNavigation'
import strings from 'lib/constants/strings'
import { GetUserQueryResult } from 'lib/graphql/graphqlTypes'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    maxWidth: '768px',
    margin: '0 auto',
    '& form': {
      width: '100%',
    },
  },
  formContainer: {
    position: 'relative',
  },
  cards: {
    '& > .MuiGrid-item': {
      [theme.breakpoints.down('sm')]: {
        '@media (min-width: 375px)': {
          flexGrow: 0,
          maxWidth: '50%',
          flexBasis: '50%',
        },
        '@media (min-width: 670px)': {
          flexGrow: 0,
          maxWidth: '33.333%',
          flexBasis: '33.333%',
        },
      },
    },
  },
  h2: {
    color: '#2E2D31',
    fontSize: '24px',
    fontWeight: 600,
    lineHeight: '32px',
    marginBottom: '16px',
  },
  text: {
    fontSize: '16px',
    lineHeight: '22px',
  },
}))
type PropsType = {
  userData: GetUserQueryResult['data']
}
const TopicCardList = ({ userData }: PropsType): ReactElement => {
  /******************************************
   * STATE
   ******************************************/

  const [isMutationSubmitting, setIsSubmitting] = useState<boolean>(false)
  const [slidingIn, setSlidingIn] = useState<boolean>(false)
  const [destination, setDestination] = useState<string>('')
  const [direction, setDirection] = useState<Direction>(Direction.LEFT)
  /******************************************
   * HOOKS
   ******************************************/

  const classes = useStyles()
  const history = useHistory()
  const navigation = useContext(NavigationContext)

  useEffect(() => {
    setSlidingIn(true)
  }, [])

  const { successHandler } = useNavigation({
    setDestination,
    setDirection,
    setSlidingIn,
    setIsSubmitting,
    isFormDirty: false,
  })
  const isMember = userData?.user?.membership.isMember

  /******************************************
   * FUNCTIONS
   ******************************************/

  const handleSaveExit = () => {
    successHandler(SuccessAction.EXIT)
  }

  const handlePrevClick = () => {
    successHandler(SuccessAction.PREV)
  }

  const handleNextClick = () => {
    isMember
      ? successHandler(SuccessAction.EXIT)
      : successHandler(SuccessAction.NEXT)
  }

  /******************************************
   * RENDER
   ******************************************/

  return (
    <>
      <Spacer size={32} fullWidth />

      <Container>
        <Grid className={classes.container} container>
          <Grid item xs={12}>
            <Typography className={classes.h2} component="h2">
              All Topics
            </Typography>
            <Typography className={classes.text} component="p">
              {strings.ONBOARDING.TOPICS.SUBTITLE}
            </Typography>
          </Grid>
        </Grid>
      </Container>

      <Spacer size={32} fullWidth />

      {/* Cards */}
      <div className={classes.formContainer}>
        <Slide
          in={slidingIn}
          timeout={500}
          direction={navigation.direction}
          onExited={() => {
            navigation.setDirection(direction)
            history.push(destination)
          }}
        >
          <div>
            <Container>
              <Grid className={classes.container} container>
                {/* Cards - Inner */}
                <TopicsList />
              </Grid>
            </Container>
          </div>
        </Slide>

        <Navigation
          handleExitOnClick={() => handleSaveExit()}
          handlePrevOnClick={() => handlePrevClick()}
          handleNextOnClick={() => handleNextClick()}
          isSubmitting={false}
          prevPage="Build Your Network"
          nextPage={isMember ? 'View your dashboard' : 'Become a Member'}
        />
      </div>
    </>
  )
}

export default TopicCardList
